import React from 'react';
import '../../styles/Events.css';
import { FaDownload } from 'react-icons/fa';
import { PhotoProvider, PhotoView } from 'react-photo-view';

export default function InnovationChallenge() {
  return (
    <div className='Innovation'>
        <div className='InnovationTitle'>CANTO Innovation Challenge</div>
        <div className='InnovationBanner'>
            <img src={process.env.PUBLIC_URL + '/assets/Innovation_Challenge_logo.png'} className='InnovationBannerLogo'/>
            <div className='InnovationBannerInfo'>
                <div className='InnovationBannerInfoSub'>
                    The CANTO Innovation Challenge empowers young innovators across the region to develop creative, tech-driven solutions that address real-world challenges in the digital sector. It provides a platform for talent, mentorship, and exposure within the Caribbean ICT ecosystem.
                    <br/><br/>
                    <a 
                        href={process.env.PUBLIC_URL + '/assets/CANTO_Innovation_Challenge_2026_Competition_Guide.pdf'} 
                        download 
                        className='InnovationDownloadButton'
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '8px',
                            backgroundColor: '#40B6BF',
                            color: 'white',
                            padding: '12px 24px',
                            borderRadius: '8px',
                            textDecoration: 'none',
                            fontWeight: 'bold',
                            fontSize: '16px'
                        }}
                    >
                        <FaDownload /> Download Competition Guide here
                    </a>
                    <br/><br/>
                    <strong>Applications close - May 25th, 2026</strong>
                </div>
            </div>
        </div>
        
        <div className='InnovationWinners'>
            <div className='InnovationWinnersInfo'>
                <div className='InnovationWinnersInfoTitle'>2025 Winners: Team 7.5</div>
                <div className='InnovationWinnersInfoSub'>
                    The winners of the 2025 CANTO Innovation Challenge were Team 7.5 from Jamaica, recognized for their ground-breaking project, Where's My Bus? Where's My Bus is a mobile solution designed to improve Jamaica's public bus system by providing commuters with real-time updates on bus locations, estimated arrival times, capacity, and operational status. By collecting and sharing live data, the app helps reduce long and unpredictable wait times, improves commuter safety and convenience, and supports smarter urban planning. This innovation aims to make public transit more reliable, efficient, and accessible- particularly for students, workers, and others who rely heavily on the bus system.
                </div>
            </div>

            <PhotoProvider className='InnovationWinnersImageContainer'>
                <PhotoView src={process.env.PUBLIC_URL + '/assets/Innovation_Challenge_1st.png'}>
                    <img src={process.env.PUBLIC_URL + '/assets/Innovation_Challenge_1st.png'} className='InnovationWinnersImage'/>
                </PhotoView>
            </PhotoProvider>
        </div>

        <div className='InnovationInfo'>
            <div className='InnovationInfoItem'>
                <div className='InnovationInfoBlock' />
                <div className='InnovationInfoBlock Sec' />
                <div className='InnovationInfoItemTitle'>The Challenge</div>
                <div className='InnovationInfoItemSub'>CANTO's Technology Trends Committee spearheads the CANTO Innovation Challenge, an initiative designed to ignite transformative progress in the Caribbean's ICT landscape. By promoting innovation and facilitating collaboration, the challenge encourages young innovators to develop impactful solutions to regional challenges, fostering partnerships and knowledge-sharing across the Caribbean technology ecosystem.<br/><br/>The 2026 edition introduces Innovation Tracks, highlighting key priority areas for the region and guiding participants to develop solutions that address real-world challenges affecting Caribbean communities, industries, and public services. Participants are encouraged to leverage emerging technologies, including Artificial Intelligence and data-driven approaches, to enhance the impact and scalability of their solutions.</div>
            </div>

            <div className='InnovationInfoItem'>
                <div className='InnovationInfoBlock' />
                <div className='InnovationInfoBlock Sec' />
                <div className='InnovationInfoItemTitle'>Problem Statement</div>
                <div className='InnovationInfoItemSub'>Develop and present an innovative product or solution that addresses a specific need or opportunity within the Caribbean's ICT and digital innovation landscape.<br/><br/>Proposed solutions must focus on real-world challenges affecting Caribbean communities, industries, or public services and should align with one of the designated Innovation Tracks. Participants are encouraged to think creatively and design solutions with strong potential for practical implementation, scalability, and measurable impact.<br/><br/>The use of emerging technologies, including Artificial Intelligence, automation, and data-driven approaches, is encouraged where appropriate to enhance the effectiveness and innovation of the proposed solution.</div>
            </div>

            <div className='InnovationInfoItem'>
                <div className='InnovationInfoBlock' />
                <div className='InnovationInfoBlock Sec' />
                <div className='InnovationInfoItemTitle'>Solutions</div>
                <div className='InnovationInfoItemSub'>
                    Proposed solutions may take a variety of forms, including but not limited to:<br/><br/>
                    • Web or mobile applications<br/>
                    • Digital platforms or data-driven tools<br/>
                    • Automation systems or decision-support tools<br/>
                    • Assistive technologies or accessibility solutions<br/>
                    • Hardware-enabled or IoT-based solutions integrated with digital systems<br/><br/>
                    Solutions should demonstrate how technology can be applied to address the identified problem in a practical and impactful way.<br/><br/>
                    Participants are encouraged to incorporate Artificial Intelligence, automation, and data-driven technologies where appropriate to enhance the effectiveness and scalability of their solutions.
                </div>
            </div>
        </div>

        <div className='InnovationJoin'>
            <div className='InnovationJoinTitle'>How to Apply</div>
            <div className='InnovationApplySubtitle' style={{textAlign: 'center', padding: '20px 40px', fontSize: '16px', lineHeight: '1.6'}}>
                To participate in the CANTO Innovation Challenge 2026, teams must complete the online application form and submit their Phase 1 proposal.<br/><br/>
                <strong>Step 1:</strong> Review the Competition Guide to understand the requirements and guidelines.<br/>
                <strong>Step 2:</strong> Complete the online application form and provide all required team and project information.<br/>
                <strong>Step 3:</strong> Upload your Phase 1 proposal document as outlined in the submission guidelines.<br/><br/>
                <strong>Apply here:</strong><br/>
                <a href='https://forms.gle/xSkENtD84R59fvXr6' target='_blank' rel='noopener noreferrer' style={{color: '#fff', textDecoration: 'none', fontWeight: 'bold'}}>https://forms.gle/xSkENtD84R59fvXr6</a><br/><br/>
                <strong style={{fontSize: '18px', color: '#fff'}}>APPLICATION DEADLINE - MAY 25TH, 2026</strong>
            </div>
        </div>

        <div className='InnovationApply'>
            <div className='InnovationApplyTitle'>Become a Mentor</div>
            <div className='InnovationApplySubtitle'>
                Are you passionate about supporting the next generation of Caribbean innovators?
            </div>
            <div className='InnovationApplyBody'>
                Join us as a mentor in the CANTO Innovation Challenge and help guide young minds as they shape the region's digital future.
                <br/><br/>
                If you're interested in mentoring these talented innovators, please contact Jenelle Edwards-Diaz at <a href='mailto:jdiaz@canto.org' style={{color: '#40B6BF', textDecoration: 'none'}}>jdiaz@canto.org</a>.
            </div>
        </div>
    </div>
  )
}
